package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class AddServiceRequest(
    val category_id: String,
    val description: String,
    val duration: Int,
    val max_price: Int,
    val name: String,
    val price: Int,
)

@Serializable
data class EditServiceRequest(
    val category_id: String,
    val description: String,
    val duration: Int,
    val max_price: Int,
    val name: String,
    val price: Int,
)